import { render, staticRenderFns } from "./HiddenCardsModal.vue?vue&type=template&id=ed4f1d8e&scoped=true&"
import script from "./HiddenCardsModal.vue?vue&type=script&lang=js&"
export * from "./HiddenCardsModal.vue?vue&type=script&lang=js&"
import style0 from "./HiddenCardsModal.vue?vue&type=style&index=0&id=ed4f1d8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4f1d8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VDialog,VRow,VSpacer,VToolbar,VToolbarTitle})
